export const dispatch = (type, detail) => {
  const event = new CustomEvent(`theme:${type}`, {
    detail,
  });

  document.dispatchEvent(event);
};

export const on = (type, callback) => {
  document.addEventListener(`theme:${type}`, callback);
};

export default {
  dispatch,
  on,
};
